import { render } from "./OrderDetails.vue?vue&type=template&id=4e8e0236"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=4e8e0236&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__